export default __webpack_public_path__ + "static/media/greenPending.cc129d50.svg";